import { getKeys } from '../../adapters/utils';
import { SD_STATUS } from '../../consts';
import { getImageObject } from '../../adapters/get-image-object';
import { getItemsSdStatus } from '../utils';
import { getBasicVideosObject } from '../../adapters/get-basic-videos-object';
export var IDs = {
    DISABLE_IMAGES_SCHEMA: 'media-component.images-schema.disable',
    IMAGES_SD_STATUS: 'media-component.structured-data.images-status',
    SD_JSON_IMAGES: 'media-component.structured-data.images',
    DISABLE_VIDEOS_SCHEMA: 'media-component.videos-schema.disable',
    VIDEOS_SD_STATUS: 'media-component.structured-data.videos-status',
    SD_JSON_VIDEOS: 'media-component.structured-data.videos',
};
var SchemaTypes = {
    MEDIA_IMAGES: 'media-images',
    MEDIA_VIDEOS: 'media-videos',
};
var userVisible = [];
var userVisibleSdOnly = [IDs.SD_JSON_IMAGES, IDs.SD_JSON_VIDEOS];
var getSdStatus = function (item, data, schemaType) {
    switch (schemaType) {
        case SchemaTypes.MEDIA_IMAGES:
            return data[IDs.IMAGES_SD_STATUS];
        case SchemaTypes.MEDIA_VIDEOS:
            return data[IDs.VIDEOS_SD_STATUS];
        default:
            return SD_STATUS.DOES_NOT_EXIST;
    }
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    getData: function (item) {
        var _a;
        var _b, _c, _d;
        var videos = ((_b = item === null || item === void 0 ? void 0 : item.videos) === null || _b === void 0 ? void 0 : _b.length) > 0
            ? (_c = getBasicVideosObject(item === null || item === void 0 ? void 0 : item.videos)) === null || _c === void 0 ? void 0 : _c.videos.filter(function (_a) {
                var thumbnailUrl = _a.thumbnailUrl, name = _a.name, uploadDate = _a.uploadDate;
                return [thumbnailUrl, name, uploadDate].every(Boolean);
            })
            : '';
        var videosSdStatus = getItemsSdStatus((item === null || item === void 0 ? void 0 : item.videos) || [], videos);
        var imagesData = (_d = item === null || item === void 0 ? void 0 : item.images) === null || _d === void 0 ? void 0 : _d.map(function (_a) {
            var imageURL = _a.url, width = _a.width, height = _a.height, altText = _a.altText;
            return ({
                url: imageURL,
                width: width,
                height: height,
                name: altText,
            });
        }).filter(function (image) { return !!image.url; });
        var _e = getImageObject('images', imagesData).images, images = _e === void 0 ? '' : _e;
        var imagesSdStatus = getItemsSdStatus((item === null || item === void 0 ? void 0 : item.images) || [], images);
        return _a = {},
            _a[IDs.SD_JSON_VIDEOS] = videos,
            _a[IDs.VIDEOS_SD_STATUS] = videosSdStatus,
            _a[IDs.DISABLE_VIDEOS_SCHEMA] = videosSdStatus !== SD_STATUS.ENABLED,
            _a[IDs.SD_JSON_IMAGES] = images,
            _a[IDs.IMAGES_SD_STATUS] = imagesSdStatus,
            _a[IDs.DISABLE_IMAGES_SCHEMA] = imagesSdStatus !== SD_STATUS.ENABLED,
            _a;
    },
    getSdStatus: getSdStatus,
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
};
